// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"154":"6c98a31b","198":"af0df335"}[chunkId] + ".chunk.css";
};